// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1TY5j","image":"Header_image__AZisw","name":"Header_name__KBSoW","info":"Header_info__2Q25T","infoRow":"Header_infoRow__1xn57"};